import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { EffectIndex } from '@/define/define'

export type LightEffectListType = { [name: LightEffectModeType]: EffectIndex }

/**
 * Jingtai V2
 */
export const LIGHT_EFFECT_LIST_JTV2: LightEffectListType = {
  [LightEffectMode.Static]: 0,
  [LightEffectMode.Wave_jingtaiV2]: 1,
  [LightEffectMode.RainbowWheel]: 7,
  [LightEffectMode.Prosperity_jtv2]: 3,
  [LightEffectMode.SpinningWindmill_jtv2]: 4,
  [LightEffectMode.BreathingRhythm_jtv2]: 8,
  [LightEffectMode.RainbowDream_jtv2]: 6,
  [LightEffectMode.SevenColorWaterfall_jtv2]: 2,
  [LightEffectMode.Scanning]: 9,
  [LightEffectMode.RainbowCluster_jtv2]: 5,
  [LightEffectMode.RainbowBeacon_jtv2]: 13,
  [LightEffectMode.HorizontalCycle_jtv2]: 10,
  [LightEffectMode.CandyRaindrop_jtv2]: 15,
  [LightEffectMode.SineWave_jtv2]: 11,
  [LightEffectMode.Starry_jtv2]: 14,
  [LightEffectMode.WaveMotion]: 12,

  [LightEffectMode.ClickHighlight_jtv2]: 16,
  [LightEffectMode.ShadowChase_jtv2]: 17,
  [LightEffectMode.InstantFlash_jtv2]: 18,
  [LightEffectMode.KeyRipple_jtv2]: 19,
  [LightEffectMode.Custom_light]: 21,
  [LightEffectMode.MusicStarry_jtv2]: 0,
  [LightEffectMode.MusicCrossFlow_jtv2]: 1,
  [LightEffectMode.MusicCloudFlow_jtv2]: 2,
  [LightEffectMode.MusicValley_jtv2]: 3,
}

/**
 * 晶泰V1
 */
export const LIGHT_EFFECT_LIST_PRO: LightEffectListType = {
  [LightEffectMode.Static_pro]: 0,
  [LightEffectMode.SaturatedStyle_pro]: 1,
  [LightEffectMode.RainbowWheel_1]: 7,
  [LightEffectMode.Prosperity_1]: 3,
  [LightEffectMode.SpinningWindmill_1]: 4,
  [LightEffectMode.BreathingRhythm_pro]: 8,
  [LightEffectMode.RainbowDream_2]: 6,
  [LightEffectMode.SevenColorWaterfall_1]: 2,
  [LightEffectMode.Scanning_1]: 5,
  [LightEffectMode.RainbowCluster_pro]: 9,
  [LightEffectMode.RainbowBeacon_pro]: 13,
  [LightEffectMode.HorizontalCycle_pro]: 10,
  [LightEffectMode.CandyRaindrop_pro]: 15,
  [LightEffectMode.SineWave_1]: 11,
  [LightEffectMode.Starry_2]: 14,
  [LightEffectMode.WaveMotion_1]: 12,
  [LightEffectMode.PixelFlow_1]: 16,
  [LightEffectMode.ClickHighlight_pro]: 17,
  [LightEffectMode.ShadowChase_pro]: 18,
  [LightEffectMode.InstantFlash_pro]: 19,
  [LightEffectMode.KeyRipple_pro]: 20,
  [LightEffectMode.Custom_light]: 100,
  [LightEffectMode.Starry_Brightness]: 0,
  [LightEffectMode.CrossFlow_Brightness]: 1,
  [LightEffectMode.CloudFlow_Brightness]: 2,
  [LightEffectMode.MusicValley_Brightness]: 3,
}

/**
 * 晶泰V1  v1.4.0 专用版本
 */
export const LIGHT_EFFECT_LIST_PRO_V140: LightEffectListType = {
  ...LIGHT_EFFECT_LIST_PRO,
  [LightEffectMode.Scanning_1]: 5,
  [LightEffectMode.RainbowBeacon_pro]: 10,
  [LightEffectMode.HorizontalCycle_pro]: 11,
  [LightEffectMode.SineWave_1]: 13,
  [LightEffectMode.RainWalk_1]: 17,
  [LightEffectMode.StarryNight_1]: 18,
  [LightEffectMode.ClickHighlight_pro]: 19,
  [LightEffectMode.Collision_2]: 20,
}

/**
 * 晶泰V1  v1.3.0 专用版本
 */
export const LIGHT_EFFECT_LIST_PRO_V130: LightEffectListType = {
  [LightEffectMode.Wave_2]: 0,
  [LightEffectMode.Prosperity_1]: 1,
  [LightEffectMode.PixelFlow_1]: 2,
  [LightEffectMode.SineWave_1]: 3,
  [LightEffectMode.RainbowDream_2]: 4,
  [LightEffectMode.RainWalk_1]: 5,
  [LightEffectMode.SpinningWindmill_1]: 6,
  [LightEffectMode.StarryNight_1]: 7,
  [LightEffectMode.RainbowWheel_1]: 8,
  [LightEffectMode.SevenColorWaterfall_1]: 9,
  [LightEffectMode.WaveMotion_1]: 10,
  [LightEffectMode.Starry_2]: 11,
  [LightEffectMode.Scanning_1]: 12,
  [LightEffectMode.Collision_2]: 13,
  [LightEffectMode.Custom_light]: 100,
  [LightEffectMode.Starry_Brightness]: 0,
  [LightEffectMode.CrossFlow_Brightness]: 1,
  [LightEffectMode.CloudFlow_Brightness]: 2,
  [LightEffectMode.MusicValley_Brightness]: 3,
}

/**
 * 容圆
 */
export const LIGHT_EFFECT_LIST_ND68: LightEffectListType = {
  [LightEffectMode.Static]: 0x01,
  [LightEffectMode.Breathing_nd68]: 0x02,
  [LightEffectMode.Neon]: 0x03,
  [LightEffectMode.Wave_nd68]: 0x04,
  [LightEffectMode.KeyRipple]: 0x05,
  [LightEffectMode.StarryNight]: 0x06,
  [LightEffectMode.HorseRace_nd68]: 0x07,
  [LightEffectMode.ClickHighlight_nd68]: 0x08,
  [LightEffectMode.Prosperity_nd68]: 0x09,
  [LightEffectMode.SineWave]: 0x0a,
  [LightEffectMode.BreathingRhythm_nd68]: 0x0b,
  [LightEffectMode.HueWave_nd68]: 0x0c,
  [LightEffectMode.InstantFlash]: 0x0e,
  [LightEffectMode.SpinningWindmill_nd68]: 0x0f,
  [LightEffectMode.RainCurtain]: 0x10,
  [LightEffectMode.RainWalk]: 0x11,
  [LightEffectMode.PixelFlow_nd68]: 0x12,
  [LightEffectMode.SnowTrace]: 0x13,
  [LightEffectMode.HorizontalCycle_nd68]: 0x17,
  [LightEffectMode.Custom_light]: 100,
}

/**
 * NA87, ND75 等
 */
export const LIGHT_EFFECT_LIST_IROKN_ST: LightEffectListType = {
  [LightEffectMode.Static_1]: 0,
  [LightEffectMode.Breathing]: 1,
  [LightEffectMode.Wave]: 2,
  [LightEffectMode.Neon_1]: 3,
  [LightEffectMode.Radar]: 4,
  [LightEffectMode.ClickHighlight]: 6,
  [LightEffectMode.Laser]: 7,
  [LightEffectMode.KeyRipple]: 8,
  [LightEffectMode.Starry_1]: 9,
  [LightEffectMode.Starry]: 0,
  [LightEffectMode.CrossFlow]: 1,
  [LightEffectMode.CloudFlow]: 2,
  [LightEffectMode.MusicValley]: 3,
  [LightEffectMode.CrossCursor]: 11,
  [LightEffectMode.KeystrokeRate]: 12,
  [LightEffectMode.RippleAutoPlay]: 14,
  [LightEffectMode.SixLineRace]: 15,
  [LightEffectMode.Fireworks]: 16,
  [LightEffectMode.Custom]: 100,
}

/**
 * AL87 Pro / AL87 RGB / FE75 PRO / FE98 PRO / MG87 / MT87 / TP87 共用
 *
 * 说明：
 * 1. 不同 lightEffectType 之间允许复用同一协议值，例如 RGB 1 与 MUSIC 1。
 * 2. 同一 lightEffectType 内不允许重复值，否则会导致回显与反查命中歧义。
 */
export const LIGHT_EFFECT_LIST_IROKN_ST_V1: LightEffectListType = {
  /* RGB */
  [LightEffectMode.Static]: 1,
  [LightEffectMode.Breathing_1]: 2,
  [LightEffectMode.Neon]: 3,
  [LightEffectMode.RainCurtain]: 5,
  [LightEffectMode.RainbowWheel]: 6,
  [LightEffectMode.StarryNight]: 8,
  [LightEffectMode.FlowingStream]: 10,
  [LightEffectMode.WaveMotion]: 11,
  [LightEffectMode.SineWave]: 13,
  [LightEffectMode.Scanning]: 14,
  [LightEffectMode.SpinningWindmill]: 15,
  [LightEffectMode.RainbowWaterfall]: 16,
  [LightEffectMode.Prosperity]: 17,
  [LightEffectMode.SpinningStorm]: 18,
  [LightEffectMode.Collision]: 19,

  /* REACT */
  [LightEffectMode.InstantFlash]: 4,
  [LightEffectMode.KeyRipple]: 7,
  [LightEffectMode.ShadowChase]: 12,
  [LightEffectMode.SnowTrace]: 9,

  /* MUSIC: protocol values can overlap RGB */
  [LightEffectMode.Starry]: 0,
  [LightEffectMode.CrossFlow]: 1,
  [LightEffectMode.CloudFlow]: 2,
  [LightEffectMode.MusicValley]: 3,

  /* CUSTOM */
  [LightEffectMode.Custom]: 100,
}

/**
 * FE98 PRO 专用
 *
 * 与 LIGHT_EFFECT_LIST_IROKN_ST_V1 的差异：
 * 1. RGB 灯效命名不同：RainbowDream(3) / RainWalk(5) / SevenColorWaterfall(16)
 * 2. 不含 Scanning(14) / Collision(19)
 */
export const LIGHT_EFFECT_LIST_FE98_PRO: LightEffectListType = {
  /* RGB */
  [LightEffectMode.Static]: 1,
  [LightEffectMode.Breathing_1]: 2,
  [LightEffectMode.RainbowDream]: 3,
  [LightEffectMode.RainWalk]: 5,
  [LightEffectMode.RainbowWheel]: 6,
  [LightEffectMode.StarryNight]: 8,
  [LightEffectMode.FlowingStream]: 10,
  [LightEffectMode.WaveMotion]: 11,
  [LightEffectMode.SineWave]: 13,
  [LightEffectMode.SpinningWindmill]: 15,
  [LightEffectMode.SevenColorWaterfall]: 16,
  [LightEffectMode.Prosperity]: 17,
  [LightEffectMode.SpinningStorm]: 18,

  /* REACT */
  [LightEffectMode.InstantFlash]: 4,
  [LightEffectMode.KeyRipple]: 7,
  [LightEffectMode.ShadowChase]: 12,
  [LightEffectMode.SnowTrace]: 9,

  /* MUSIC: protocol values can overlap RGB */
  [LightEffectMode.Starry]: 0,
  [LightEffectMode.CrossFlow]: 1,
  [LightEffectMode.CloudFlow]: 2,
  [LightEffectMode.MusicValley]: 3,

  /* CUSTOM */
  [LightEffectMode.Custom]: 100,
}

/**
 * OP75 专用（不含 SnowTrace / Scanning / SpinningStorm / Collision）
 */
export const LIGHT_EFFECT_LIST_OP75: LightEffectListType = {
  /* RGB */
  [LightEffectMode.Static]: 1,
  [LightEffectMode.Breathing_1]: 2,
  [LightEffectMode.Neon]: 3,
  [LightEffectMode.RainCurtain]: 5,
  [LightEffectMode.RainbowWheel]: 6,
  [LightEffectMode.StarryNight]: 8,
  [LightEffectMode.FlowingStream]: 10,
  [LightEffectMode.WaveMotion]: 11,
  [LightEffectMode.SineWave]: 13,
  [LightEffectMode.SpinningWindmill]: 15,
  [LightEffectMode.RainbowWaterfall]: 16,
  [LightEffectMode.Prosperity]: 17,

  /* REACT */
  [LightEffectMode.InstantFlash]: 4,
  [LightEffectMode.KeyRipple]: 7,
  [LightEffectMode.ShadowChase]: 12,

  /* MUSIC: protocol values can overlap RGB */
  [LightEffectMode.Starry]: 0,
  [LightEffectMode.CrossFlow]: 1,
  [LightEffectMode.CloudFlow]: 2,
  [LightEffectMode.MusicValley]: 3,

  /* CUSTOM */
  [LightEffectMode.Custom]: 100,
}

/**
 * MG63/RA68 火柴人
 */
export const LIGHT_EFFECT_LIST_HuoChaiRen: LightEffectListType = {
  [LightEffectMode.Close]: 0,
  [LightEffectMode.Wave_mg63]: 1,
  [LightEffectMode.RainbowWheel]: 2,
  [LightEffectMode.SpinningWindmill_nd68]: 3,
  [LightEffectMode.HueBreathing_mg63]: 4,
  [LightEffectMode.BreathingRhythm_mg63]: 5,
  [LightEffectMode.Static]: 6,
  [LightEffectMode.RainbowDream_mg63]: 10,
  [LightEffectMode.StarryNight]: 11,
  [LightEffectMode.CandyRaindrop_huochairen]: 12,
  [LightEffectMode.SineWave_mg63]: 13,
  [LightEffectMode.SpiralCycle_mg63]: 14,
  [LightEffectMode.RainCurtain]: 15,
  [LightEffectMode.Scanning_mg63]: 16,
  [LightEffectMode.HorseRace]: 17,
  [LightEffectMode.Prosperity_mg63]: 18,
  [LightEffectMode.Custom_light]: 100,
  [LightEffectMode.KeyRipple_mg63]: 7,
  [LightEffectMode.ClickHighlight_jtv2]: 8,
  [LightEffectMode.InstantFlash_mg63]: 9,

  [LightEffectMode.Starry_Brightness]: 0,
  [LightEffectMode.CrossFlow_Brightness]: 1,
  [LightEffectMode.CloudFlow_Brightness]: 2,
  [LightEffectMode.MusicValley_Brightness]: 3,
}

/**
 * MG63/RA68 火柴人
 */
export const LIGHT_EFFECT_LIST_MG63: LightEffectListType = {
  ...LIGHT_EFFECT_LIST_HuoChaiRen,
  [LightEffectMode.SideClose]: 0x0,
  [LightEffectMode.SideWave_RA68_1]: 0x01,
  [LightEffectMode.SideNeon]: 0x02,
  [LightEffectMode.SideBreathing_RA68_1]: 0x03,
  [LightEffectMode.SideHorseRace]: 0x04,
  [LightEffectMode.SideFleeting_RG68_1]: 0x05,
  [LightEffectMode.SideStatic_RA68_1]: 0x06,
}

/**
 * FE87 V2 固件 v2.1.2 专用
 */
export const LIGHT_EFFECT_LIST_FE87V2_V212: LightEffectListType = {
  [LightEffectMode.Static_pro]: 3,
  [LightEffectMode.SaturatedStyle_FE87]: 0,
  [LightEffectMode.Prosperity_FE87]: 1,
  [LightEffectMode.SpinningWindmill_1]: 6,
  [LightEffectMode.Scanning_2]: 5,

  [LightEffectMode.ClickHighlight_pro]: 0x11,
  [LightEffectMode.ShadowChase_pro]: 0x12,
  [LightEffectMode.KeyRipple_pro]: 0x14,

  [LightEffectMode.SideStatic]: 0x0,
  [LightEffectMode.SideFleeting]: 0x1,
  [LightEffectMode.SideSpectrumCycle]: 0x2,
  [LightEffectMode.SideBreathing]: 0x3,
}

/**
 * FE87 V2 固件 v2.1.5+ 新增灯效
 */
const _fe87V2V215Base = (({ [LightEffectMode.Static_pro]: _, ...rest }) => rest)(LIGHT_EFFECT_LIST_FE87V2_V212)
export const LIGHT_EFFECT_LIST_FE87V2_V215: LightEffectListType = {
  ..._fe87V2V215Base,
  [LightEffectMode.Static_FE87]: 3,
  [LightEffectMode.HorizontalSpread_FE87]: 0x15,
  [LightEffectMode.VerticalSpread_FE87]: 0x16,
  [LightEffectMode.StarryNight]: 0x17,
  [LightEffectMode.SineWave]: 0x18,
  [LightEffectMode.FlowingStream]: 0x19,
  [LightEffectMode.MatrixRain_FE87]: 0x1a,
  [LightEffectMode.ParticleCollision_FE87]: 0x1b,
  [LightEffectMode.Meteor_FE87]: 0x1c,
  [LightEffectMode.Aurora_FE87]: 0x1d,
  [LightEffectMode.HolidayLights_FE87]: 0x1e,
  [LightEffectMode.Heartbeat_FE87]: 0x1f,
  [LightEffectMode.Converge_FE87]: 0x20,
  [LightEffectMode.NeonPulse_FE87]: 0x21,
  [LightEffectMode.RainbowBreathe_FE87]: 0x22,
  [LightEffectMode.SpectralRaindrop_FE87]: 0x23,
}

/**
 * FE87 C18 纯机械轴 基础灯效（v1.0.5 以下）
 */
export const LIGHT_EFFECT_LIST_FE87_C18: LightEffectListType = {
  [LightEffectMode.Static_pro]: 3,
  [LightEffectMode.SaturatedStyle_FE87]: 0,
  [LightEffectMode.Prosperity_FE87]: 1,
  [LightEffectMode.SpinningWindmill_1]: 6,
  [LightEffectMode.Scanning_2]: 5,

  [LightEffectMode.SideStatic]: 0x0,
  [LightEffectMode.SideFleeting]: 0x1,
  [LightEffectMode.SideSpectrumCycle]: 0x2,
  [LightEffectMode.SideBreathing]: 0x3,
}

/**
 * FE87 C18 固件 v1.0.5+ 新增灯效
 */
const _fe87C18V105Base = (({ [LightEffectMode.Static_pro]: _, ...rest }) => rest)(LIGHT_EFFECT_LIST_FE87_C18)
export const LIGHT_EFFECT_LIST_FE87_C18_V105: LightEffectListType = {
  ..._fe87C18V105Base,
  [LightEffectMode.Static_FE87]: 3,
  [LightEffectMode.HorizontalSpread_FE87]: 0x15,
  [LightEffectMode.VerticalSpread_FE87]: 0x16,
  [LightEffectMode.StarryNight]: 0x17,
  [LightEffectMode.SineWave]: 0x18,
  [LightEffectMode.FlowingStream]: 0x19,
  [LightEffectMode.MatrixRain_FE87]: 0x1a,
  [LightEffectMode.ParticleCollision_FE87]: 0x1b,
  [LightEffectMode.Meteor_FE87]: 0x1c,
  [LightEffectMode.Aurora_FE87]: 0x1d,
  [LightEffectMode.HolidayLights_FE87]: 0x1e,
  [LightEffectMode.Heartbeat_FE87]: 0x1f,
  [LightEffectMode.Converge_FE87]: 0x20,
  [LightEffectMode.NeonPulse_FE87]: 0x21,
  [LightEffectMode.RainbowBreathe_FE87]: 0x22,
  [LightEffectMode.SpectralRaindrop_FE87]: 0x23,
}
